export enum Color {
    BLACK = "BLACK",
    WHITE = "WHITE"
}

export const EMPTY_BANNER = {
    bannerText: "",
    textSize: 10,
    textColor: Color.WHITE,
    imageLink: "",
    imageBlur: 0,
    imageZoom: 100,
    imageTopX: 0,
    imageTopY: 0,

    opacity: 50
}